import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';

@Component({
  selector: 'app-pdf-template-navigation',
  templateUrl: './pdf-template-navigation.component.html',
  styleUrls: ['./pdf-template-navigation.component.css']
})
export class PdfTemplateNavigationComponent implements OnInit {

  constructor(
    private httpService: HttpService,
    public pdfTemplateService: PdfDocumentTemplateService
  ) { }

  public get viewOption(): typeof PdfTemplateViewOption {
    return PdfTemplateViewOption;
  }

  ngOnInit(): void {
  }

  createBookingDocumentTemplate() {
    this.pdfTemplateService.activeItemId = PdfTemplateViewOption.CREATE_BOOKING_RELATED;
  }

  createContactRequestDocumentTemplate() {
    this.pdfTemplateService.activeItemId = PdfTemplateViewOption.CREATE_CONTACT_REQUEST_RELATED;
  }

  updateTemplates() {
    switch (this.pdfTemplateService.activeItemId) {
      case PdfTemplateViewOption.BOOKING_RELATED:
        this.httpService.getPdfDocumentTemplatesByLanguageId(this.pdfTemplateService.selectedLanguage.id).subscribe(res => {
          this.pdfTemplateService.bookingPdftemplates = res;
        });
        break;
      case PdfTemplateViewOption.CONTACT_REQUEST_RELATED:
        this.httpService.getContactRequestQuotationTemplatesByLanguage(this.pdfTemplateService.selectedLanguage).subscribe(res => {
          this.pdfTemplateService.contactRequestPdfTemplates = res;
        });
        break;
      case PdfTemplateViewOption.FINAL_CONFIRMATIONS:
        this.httpService.getBookingFinalConfirmationTemplatesByLanguageId(this.pdfTemplateService.selectedLanguage.id).subscribe(res => {
          this.pdfTemplateService.finalConfirmationTemplates = res;
        });
        break;
      case PdfTemplateViewOption.CONFIRMATIONS:
        this.httpService.getBookingConfirmationTemplatesByLanguageId(this.pdfTemplateService.selectedLanguage.id).subscribe(res => {
          this.pdfTemplateService.confirmationTemplates = res;
        });
        break;
    }
  }

}
